if (!customElements.get("cart-aside")) {
  class CartAside extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (!event.detail.cartAsideHTML) return;

      this.innerHTML = event.detail.cartAsideHTML.innerHTML;
    }

    disconnectedCallback() {
      document.removeEventListener("cart:update-html", this.handleUpdateRef);
    }

    connectedCallback() {
      document.addEventListener("cart:update-html", this.handleUpdateRef);
    }
  }

  customElements.define("cart-aside", CartAside);
}
